import React, { useEffect, useState } from 'react'
import api from '../../api/axios';
import { ChevronDown } from 'lucide-react';

const Layout6Form = ({ data, onChange, errors }) => {
    const { video, brand, title, product } = data;

    const [campaigns, setCampaigns] = useState([]);

    const handleChange = (section, field, value) => {
        // let cleanedValue = (value || '').replace(/%/g, "");

        let cleanedValue = value;

        // Only clean string values
        if (typeof value === "string") {
            cleanedValue = (value || '').replace(/%/g, "");
        }

        if (field === 'url' || field === 'logoUrl' || field === 'imageUrl' || field === 'qrCodeUrl') {
            cleanedValue = value
        }
        onChange('layout6', section, field, cleanedValue);
    };

    const getCampaigns = async () => {
        try {
            const response = await api.get('campaign/list');
            if (response && response.data && response.data.data) {
                setCampaigns(response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getCampaigns();
    }, []);

    return (
        <div className="h-[calc(100vh-220px)] overflow-y-auto p-4">
            {/* Canvas Settings */}
            <div className="form-section">

                <div className="form-group">
                    <label>Campaign Name</label>
                    <div className='relative'>
                        <select
                            value={data.camp_name}
                            onChange={(e) => handleChange(null, 'camp_name', e.target.value)}
                            className={`appearance-none ${errors?.camp_name ? "has-error" : ""} `}
                        >
                            <option value="">Select Campaign</option>
                            {campaigns.map((camp) => (
                                <option key={camp.camp_id} value={camp.camp_name}>
                                    {camp.camp_name}
                                </option>
                            ))}
                        </select>
                        <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
                    </div>
                    {errors?.camp_name && (
                        <p className="text-red-500 text-sm mt-1">
                            {errors.camp_name}
                        </p>
                    )}
                </div>

                <div className="form-group">
                    <label>Brand Name</label>

                    <input
                        type="text"
                        value={data.brand_name || ''}
                        onChange={(e) => handleChange(null, 'brand_name', e.target.value)}
                        className={errors?.brand_name ? "has-error" : ""}
                    />
                    {errors?.brand_name && (
                        <p className="text-red-500 text-sm mt-1">
                            {errors.brand_name}
                        </p>
                    )}
                </div>

                <div className="form-group">
                    <label>Domain</label>
                    <input
                        type="text"
                        value={data.domain || ''}
                        onChange={(e) => handleChange(null, 'domain', e.target.value)}
                        className={errors?.domain ? "has-error" : ""}
                    />
                    {errors?.domain && (
                        <p className="text-red-500 text-sm mt-1">
                            {errors.domain}
                        </p>
                    )}
                </div>

                <div className="form-group">
                    <label>Creative Name</label>
                    <input
                        type="text"
                        value={data.creative_name || ''}
                        onChange={(e) => handleChange(null, 'creative_name', e.target.value)}
                        className={errors?.creative_name ? "has-error" : ""}
                    />
                    {errors?.creative_name && (
                        <p className="text-red-500 text-sm mt-1">
                            {errors.creative_name}
                        </p>
                    )}
                </div>
            </div>

            {/* Video Section */}
            <div className="form-section">
                <h3>Canvas and video settings</h3>

                <div className="form-group">
                    <label>Background Color</label>
                    <div className="color-input-group">
                        <input
                            type="color"
                            value={data.canvas?.backgroundColor || '#6b1f23'}
                            onChange={(e) => handleChange('canvas', 'backgroundColor', e.target.value)}
                        />
                        <input
                            type="text"
                            value={data.canvas?.backgroundColor || '#6b1f23'}
                            onChange={(e) => handleChange('canvas', 'backgroundColor', e.target.value)}
                            placeholder="#6b1f23"
                            className="color-text-input"
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label>Border Color</label>
                    <div className="color-input-group">
                        <input
                            type="color"
                            value={data.canvas?.borderColor || '#6b1f23'}
                            onChange={(e) => handleChange('canvas', 'borderColor', e.target.value)}
                        />
                        <input
                            type="text"
                            value={data.canvas?.borderColor || '#6b1f23'}
                            onChange={(e) => handleChange('canvas', 'borderColor', e.target.value)}
                            placeholder="#6b1f23"
                            className="color-text-input"
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label>Video URL (1920 x 1080)</label>
                    <input
                        type="text"
                        value={video.url}
                        onChange={(e) => handleChange('video', 'url', e.target.value)}
                        placeholder="Enter video URL"
                    />
                    <span className='text-xs text-blue-500'>Aspect ratio: (1920 x 1080)</span>
                </div>

                <div className="form-group">
                    <label>Title</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => handleChange(null, 'title', e.target.value)}
                        placeholder="Conquer Every Moment"
                        maxLength={20}
                    />
                </div>

                <div className="form-group">
                    <label>Title Text Color</label>
                    <div className="color-input-group">
                        <input
                            type="color"
                            value={data.canvas?.titleTextColor || '#121212'}
                            onChange={(e) => handleChange('canvas', 'titleTextColor', e.target.value)} />
                        <input
                            type="text"
                            value={data.canvas?.titleTextColor || '#121212'}
                            onChange={(e) => handleChange('canvas', 'titleTextColor', e.target.value)}
                            placeholder="#121212"
                            className="color-text-input" />
                    </div>
                </div>

            </div>

            {/* Brand Section */}
            <div className="form-section">
                <h3>Brand</h3>

                <div className="form-group">
                    <label>Product URL</label>
                    <input
                        type="text"
                        value={product}
                        onChange={(e) => handleChange(null, 'product', e.target.value)}
                        placeholder="Enter logo URL"
                    />
                    <p className="text-blue-600 text-xs">
                        Image must be at least 450 × 450 pixels.
                    </p>
                </div>

                <div className="form-group">
                    <label>Logo URL</label>
                    <input
                        type="text"
                        value={brand.logoUrl}
                        onChange={(e) => handleChange('brand', 'logoUrl', e.target.value)}
                        placeholder="Enter logo URL"
                    />
                    <p className="text-blue-600 text-xs">
                        Image must be at least 200 × 200 pixels.
                    </p>
                </div>

                <div className="form-group">
                    <label>QR Code URL</label>
                    <input
                        type="text"
                        value={brand?.qrCodeUrl || ''}
                        onChange={(e) => handleChange('brand', 'qrCodeUrl', e.target.value)}
                        placeholder="Enter QR code URL"
                    />
                </div>

            </div>

        </div>
    )
}

export default Layout6Form